export default __webpack_public_path__ + "static/media/Location_Bayern.d067b08f.svg";